// tracking.js


const trackClick = (eventCategory, eventAction, eventLabel, languageData) => {

    if (window != 'undefined' && window.gtag) {
        
        window.gtag('event', eventAction, {
            'event_category': eventCategory,
            'event_label': eventLabel,
            'language': languageData,
          });
  }
};

export default trackClick;